const styles = () => ({
    root: {
        width: '16em',
        minWidth: '16em',
    },
});

export default styles;
